<div>
  <form [formGroup]="form">
    <div class="fields-container">
      <div class="field-control">
        <app-boolean
          [control]="form.get('isResident')"
          [options]="standardOption"
          [label]="'OWNER_FORM.RESIDENCY' | translate"
          />
        </div>

        <!--  UAE-residents ONLY ------>
        @if (form.get('isResident')?.value === '1' || form.get('isResident')?.value === fieldValue.YES || form.get('isResident')?.value === fieldValue.YES_AR) {
          <div class="field-control">
            <app-text-field
              [control]="form.get('emiratesId')"
              [label]="'OWNER_FORM.EMIRATES_ID' | translate"
              />
            </div>
            <div class="field-control">
              <!-- <label class="field-label">{{ "OWNER_FORM.DOB" | translate }}</label> -->
              <div class="field-control">
                <app-date
                  [control]="form.get('emiratesDob')"
                  [label]="'OWNER_FORM.DOB' | translate"
                  [allowedDate]="'past'"
                  />
                </div>
              </div>
              <div class="buttons-group">
                <app-button
                  [type]="'button'"
                  [label]="'BUTTONS.CHECK_DETAIL' | translate"
                  classesName="card-edge-cut-white btn-edge-cut"
                  (onBtnClick)="detailFound = true"
                  />
                </div>
                <!-- if not detail found show message -->
                @if (!detailFound) {
                  <app-validation-message
                    type="error"
                    [content]="{title:'ALERT.NO_RESULTS_TITLE' | translate, message:'ALERT.NO_RESULTS_DESC' | translate}"
                    />
                }
                <!-- user detail -->
                <div class="mt-5 mb-5 space-y-4">
                  <table class="w-full text-sm text-dc-navy">
                    <tbody>
                      <tr class="border-b">
                        <td class="py-2 font-medium">
                          {{ "OWNER_FORM.NAME_EN" | translate }}
                        </td>
                        <td class="py-2">Rizma Palathingal</td>
                      </tr>
                      <tr class="border-b">
                        <td class="py-2 font-medium">
                          {{ "OWNER_FORM.NAME_AR" | translate }}
                        </td>
                        <td class="py-2">ريزما بالاثينجال</td>
                      </tr>
                      <tr class="border-b">
                        <td class="py-2 font-medium">
                          {{ "OWNER_FORM.NATIONALITY" | translate }}
                        </td>
                        <td class="py-2">Indian</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              }

              <!-- NON-residents ONLY ----->
              @if (form.get('isResident')?.value === '2') {
                <div class="field-control">
                  <app-text-field
                    [control]="form.get('passportNumber')"
                    [label]="'OWNER_FORM.PASSPORT_NO' | translate"
                    />
                  </div>
                  <div class="field-control">
                    <!-- <label class="field-label">{{
                      "OWNER_FORM.PASSPORT_EXPIRY" | translate
                    }}</label> -->
                    <div class="field-control">
                      <app-date
                        [allowedDate]="'future'"
                        [control]="form.get('passportExpiry')"
                        [label]="'OWNER_FORM.PASSPORT_EXPIRY' | translate"
                        />
                      </div>
                    </div>
                  }

                  <!-- INDIVIDUAL fields ---------->
                  @if (form.get('isResident')?.value === '2') {
                    <div class="field-control">
                      <app-text-field
                        [control]="form.get('nameEn')"
                        [label]="'OWNER_FORM.NAME_EN' | translate"
            [validationMessages]="{
              english: 'VALIDATION_MSG.EN_LETTERS' | translate
            }"
                        />
                      </div>
                      <div class="field-control">
                        <app-text-field
                          [control]="form.get('nameAr')"
                          [label]="'OWNER_FORM.NAME_AR' | translate"
            [validationMessages]="{
              arabic: 'VALIDATION_MSG.AR_LETTERS' | translate
            }"
                          />
                        </div>
                        <div class="field-control">
                          <app-option-field
                            [control]="form.get('nationality')"
                            [options]="nationalities"
                            [label]="'OWNER_FORM.NATIONALITY' | translate"
                            [country]="true"
                            />
                          </div>
                        }

                        <!----- OWNER / PARTNER EXCLUSIVE ----------->
                        <ng-container>
                          <div class="field-control">
                            <app-text-field
                              [control]="form.get('mobile')"
                              [label]="'OWNER_FORM.MOBILE' | translate"
                              />
                            </div>
                            <div class="field-control">
                              <app-text-field
                                [control]="form.get('email')"
                                [label]="'OWNER_FORM.EMAIL' | translate"
            [validationMessages]="{
              email: 'VALIDATION_MSG.VALID_EMAIL' | translate
            }"
                                />
                              </div>
                            </ng-container>

                            <!-- Attachments -->
                            @if (form.get('isResident')?.value === '2') {
                              <h1 class="section-heading">
                                {{ "UPLOAD_DOCUMENTS" | translate }}
                              </h1>
                            }
                            <!-- passport copy upload -->
                            @if (form.get('isResident')?.value === '2') {
                              <div class="field-control">
                                <app-file
                                  [title]="'OWNER_FORM.UPLOAD_PASSPORT' | translate"
                                  [attachments]="filesList"
                                  (onUploadRemove)="handleFileUpload($event)"
                                  (removeFile)="handleFileRemove($event)"
                                  />
                                </div>
                              }

                              <!-- ROLE ------------>
                              <div class="field-control">
                                <app-checkbox
                                  [control]="form.get('roles')"
                                  [options]="roles"
                                  [label]="'OWNER_FORM.ROLE' | translate"
                                  />
                                </div>
                                <!----- SUBMIT actions --------->
                                <div class="buttons-group">
                                  <app-button
                                    type="button"
                                    classesName="btn-edge-cut  btn-width-auto"
                                    [label]="'BUTTONS.ADD' | translate"
                                    (onBtnClick)="addSignatory()"
                                    />
                                    <app-button
                                      type="button"
                                      classesName="card-edge-cut-white btn-width-auto"
                                      [label]="'BUTTONS.SAVE_CLOSE' | translate"
                                      (onBtnClick)="close()"
                                      />
                                    </div>
                                  </div>
                                </form>
                              </div>
